<template>
  <v-select v-model="language" :items="languageValue">
    <template slot="selection" slot-scope="data">
      <img :src="data.item.avatar" width="20px" alt="avatar" />
      &nbsp;&nbsp;{{ data.item.text }}
    </template>
    <template slot="item" slot-scope="data">
      <img :src="data.item.avatar" width="20px" alt="avatar" />
      &nbsp;&nbsp;{{ data.item.text }}
    </template>
  </v-select>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { setApiIso } from '@/helpers'
export default {
  name: 'LSelect',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      language: localStorage.getItem('locale') || 'es',
    }
  },
  watch: {
    language: function (val) {
      this.changeLocale(val)
      location.reload()
    },
    languageList: function (val) {
      if (val && !localStorage.getItem('iso')) this.setISO('es')

      if (val && !localStorage.getItem('defaultISO')) {
        const language = this.languageList.find(
          (language) => language.iso.split('-')[0] === 'es'
        )
        const defaultISO = language ? language.iso : 'es-ES'
        localStorage.setItem('defaultISO', defaultISO)
      }
    },
  },
  computed: {
    ...mapState({
      languageList: (state) => state.languages.list,
    }),
    languageValue() {
      let result = []
      this.items.forEach((item) => {
        result.push({
          text: item.title,
          value: item.language,
          avatar: `/static/flags/${item.flag}.svg`,
        })
      })
      return result
    },
  },
  methods: {
    changeLocale(locale) {
      moment.locale(locale)
      this.$i18n.locale = locale
      this.$vuetify.lang.current = locale
      localStorage.setItem('locale', locale)
      this.setISO(locale)
    },
    setISO(locale) {
      if (!this.languageList) return
      let language = this.languageList.find(
        (language) => language.iso.split('-')[0] === locale
      )
      if (!language) {
        language = this.languageList.find(
          (language) => language.iso.split('-')[0] === 'es'
        )
      }
      const iso = language ? language.iso : 'es-ES'
      localStorage.setItem('iso', iso)
      setApiIso(iso)
    },
  },
}
</script>
